import { render, staticRenderFns } from "./DashboardBody.vue?vue&type=template&id=ec530984"
import script from "./DashboardBody.vue?vue&type=script&lang=js"
export * from "./DashboardBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports